module.exports = __webpack_public_path__ + "static/img/图层 587.6fc6acb4.png";